import React from 'react';
import {withTranslation} from "react-i18next";

let ErrorComponent = ({messageKey, t}) => {
	return <div className="row error-container">
		<div className="col-3">
			<span className="exclamation-sign"></span>
		</div>
		<div className="col-9 align-self-center">
			{t(messageKey)}
		</div>

	</div>;
};

export default withTranslation() (ErrorComponent)